import { render, staticRenderFns } from "./OfficialActiveSliderBar.vue?vue&type=template&id=f3bc7e1c&scoped=true"
import script from "./OfficialActiveSliderBar.vue?vue&type=script&lang=js"
export * from "./OfficialActiveSliderBar.vue?vue&type=script&lang=js"
import style0 from "./OfficialActiveSliderBar.vue?vue&type=style&index=0&id=f3bc7e1c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3bc7e1c",
  null
  
)

export default component.exports